import React, { Component } from 'react';
import { ThemeProvider } from '@material-ui/styles';
// import { createMuiTheme } from '@material-ui/core/styles';
import './App.css';
import Routes from './routes';
import MainProvider from './MainProvider';
import { CookiesProvider } from 'react-cookie';
import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#025a3c',
      gray: '#7a7a7a',
      bg: '#dedee6',
    },
    secondary: {
      main: '#ecd251',
    },

    third: {
      main: '#47ad89',
    },
  },
  typography: {
    // fontFamily: ['"Noto Sans"', '"Lato"', 'sans-serif'].join(','),
    fontFamily: ['"Arial"', '"Lato"', 'sans-serif'].join(','),
  },
});

class App extends Component {
  render() {
    return (
      <MainProvider isTimerRunning={true}>
        <div style={{ height: '100%', backgroundColor: '#ffffff' }}>
          <ThemeProvider theme={theme}>
            <CookiesProvider>
              <Routes />
            </CookiesProvider>
          </ThemeProvider>
        </div>
      </MainProvider>
    );
  }
}

export default App;
